import { render, staticRenderFns } from "./PatientNoteAddEdit.vue?vue&type=template&id=c905ae82"
import script from "./PatientNoteAddEdit.vue?vue&type=script&lang=js"
export * from "./PatientNoteAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports